export default "__VITE_ASSET__C$nldh4S__";